import React from "react";
import { ClothesAndAccessoriesForm } from "../../components/Forms/ClothesAndAccessoriesForm";

const NewClothesAndAccessories = () => {
  return <ClothesAndAccessoriesForm></ClothesAndAccessoriesForm>;
};

export default NewClothesAndAccessories;
